/* GOOGLE MAP */
let map, mapBallymount, mapGlasnevin;
export function initMap() {
    /*const styles = [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#cceeff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#cccccc"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffffff"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 17
                },
                {
                    "color": "#111111"
                },
                {
                    "lightness": 30
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e7e7e7"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#fefefe"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        }
    ];*/
    
    //const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    //const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    //  "marker"
    //);

    if(document.getElementById("map")) {
        map = new google.maps.Map(document.getElementById("map"), {
            center: new google.maps.LatLng(53.354999, -6.324760),
            disableDefaultUI: true,
            //styles: styles,
            zoom: 11,
        });
    }

    // if(document.querySelector(".map-location")) { // For multiple maps
    //     map = new google.maps.Map(document.querySelector(".map-location"), {
    //         center: new google.maps.LatLng(53.354999, -6.324760),
    //         disableDefaultUI: true,
    //         //styles: styles,
    //         zoom: 11,
    //     });
    // }

    const iconBase = "/wp-content/themes/space-self-storage/assets/icons/";
    const icons = {
        location: {
            icon: iconBase + "map-pin.png",
        },
    };
    const features = [
        {
            //position: new google.maps.LatLng(53.373720, -6.295250),
            position: new google.maps.LatLng(53.320999, -6.354760),
            title: "South Dublin - Ballymount",
            content: "Unit 6 Crosslands Business Park<br>Ballymount Road<br>Lower Ballymount<br>Dublin 12<br>D12 R7A4",
            type: "location",
        },
        {
            //position: new google.maps.LatLng(53.320999, -6.354760),
            position: new google.maps.LatLng(53.373720, -6.295250),
            title: "North Dublin - Glasnevin",
            content: "Nore Road<br>Dublin Industrial Est<br>Glasnevin<br>Dublin 11<br>D11 EH97",
            type: "location",
        },
    ];
    // Create an info window to share between markers.
    //const infoWindow = new InfoWindow();
    //const priceTag = document.createElement("div");
    //priceTag.className = "price-tag";
    //priceTag.textContent = "$2.5M";

    for (let i = 0; i < features.length; i++) {
        const contentString = // TODO: get HTML from page?
        '<div id="content"><div id="siteNotice"></div>' +
        '<h2 id="firstHeading" class="firstHeading">'+features[i].title+'</h2>' +
        '<div id="bodyContent">' +
        '<p>'+features[i].content+'</p>' +
        '</div></div>';
        const infoWindow = new google.maps.InfoWindow({
            content: contentString,
            //ariaLabel: "Location",
        });
        const marker = new google.maps.Marker({
            position: features[i].position,
            icon: icons[features[i].type].icon,
            title: features[i].title,
            //title: `${i + 1}. ${title}`,
            //styles: styles,
            map: map,
        });
        marker.addListener("click", () => {
          //infoWindow.close(); // Doesn't work - need a static window and switch content/position
          //infoWindow.setContent(contentString);
          infoWindow.open({
            anchor: marker,
            map,
          });
        });
        /*const pin = new PinElement({
            glyph: `${i + 1}`,
        });
        const marker = new AdvancedMarkerElement({
            map,
            position,
            //features[i].position,
            icon: icons[features[i].type].icon,
            title: `${i + 1}. ${title}`,
            content: pin.element,
        });
        // Add a click listener for each marker, and set up the info window.
        marker.addListener("click", ({ domEvent, latLng }) => {
            const { target } = domEvent;
            infoWindow.close();
            infoWindow.setContent(marker.title);
            infoWindow.open(marker.map, marker);
          });*/

        /* .forEach(({ position, title }, i) => {
            const pin = new PinElement({
              glyph: `${i + 1}`,
            });
            const marker = new AdvancedMarkerElement({
              position,
              map,
              title: `${i + 1}. ${title}`,
              content: pin.element,
            });
        
            // Add a click listener for each marker, and set up the info window.
            marker.addListener("click", ({ domEvent, latLng }) => {
              const { target } = domEvent;
        
              infoWindow.close();
              infoWindow.setContent(marker.title);
              infoWindow.open(marker.map, marker);
            });
          }); */
    }
    
    if(document.querySelector(".map-ballymount")) { // For multiple maps
        mapBallymount = new google.maps.Map(document.querySelector(".map-ballymount"), {
            //center: new google.maps.LatLng(53.373720, -6.295250),
            center: new google.maps.LatLng(53.320999, -6.354760),
            disableDefaultUI: true,
            //styles: styles,
            zoom: 11,
        });
        const ballymountContentString = // TODO grab HTML from page
        '<div id="content"><div id="siteNotice"></div>' +
        '<h2 id="firstHeading" class="firstHeading">'+features[0].title+'</h2>' +
        '<div id="bodyContent">' +
        '<p>'+features[0].content+'</p>' +
        '</div></div>';
        const ballymountInfoWindow = new google.maps.InfoWindow({
            content: ballymountContentString,
            //ariaLabel: "Location",
        });
        const markerBallymount = new google.maps.Marker({
            position: features[0].position,
            icon: icons[features[0].type].icon,
            title: features[0].title,
            //title: `${i + 1}. ${title}`,
            //styles: styles,
            map: mapBallymount,
        });
        markerBallymount.addListener("click", () => {
        //infoWindow.close(); // Doesn't work - need a static window and switch content/position
        //infoWindow.setContent(contentString);
        ballymountInfoWindow.open({
            anchor: markerBallymount,
            mapBallymount,
        });
        });
    //     map = new google.maps.Map(document.querySelector(".map-location"), {
    //         center: new google.maps.LatLng(53.354999, -6.324760),
    //         disableDefaultUI: true,
    //         //styles: styles,
    //         zoom: 11,
    //     });
    }

    if(document.getElementById("map-ballymount")) {
        mapBallymount = new google.maps.Map(document.getElementById("map-ballymount"), {
            //center: new google.maps.LatLng(53.373720, -6.295250),
            center: new google.maps.LatLng(53.320999, -6.354760),
            disableDefaultUI: true,
            //styles: styles,
            zoom: 11,
        });
        const ballymountContentString = // TODO grab HTML from page
        '<div id="content"><div id="siteNotice"></div>' +
        '<h2 id="firstHeading" class="firstHeading">'+features[0].title+'</h2>' +
        '<div id="bodyContent">' +
        '<p>'+features[0].content+'</p>' +
        '</div></div>';
        const ballymountInfoWindow = new google.maps.InfoWindow({
            content: ballymountContentString,
            //ariaLabel: "Location",
        });
        const markerBallymount = new google.maps.Marker({
            position: features[0].position,
            icon: icons[features[0].type].icon,
            title: features[0].title,
            //title: `${i + 1}. ${title}`,
            //styles: styles,
            map: mapBallymount,
        });
        markerBallymount.addListener("click", () => {
          //infoWindow.close(); // Doesn't work - need a static window and switch content/position
          //infoWindow.setContent(contentString);
          ballymountInfoWindow.open({
            anchor: markerBallymount,
            mapBallymount,
          });
        });
    }

    if(document.getElementById("map-glasnevin")) {
        mapGlasnevin = new google.maps.Map(document.getElementById("map-glasnevin"), {
            //center: new google.maps.LatLng(53.320999, -6.354760),
            center: new google.maps.LatLng(53.373720, -6.295250),
            disableDefaultUI: true,
            //styles: styles,
            zoom: 11,
        });
        const glasnevinContentString = // TODO grab HTML from page
        '<div id="content"><div id="siteNotice"></div>' +
        '<h2 id="firstHeading" class="firstHeading">'+features[1].title+'</h2>' +
        '<div id="bodyContent">' +
        '<p>'+features[1].content+'</p>' +
        '</div></div>';
        const glasnevinInfoWindow = new google.maps.InfoWindow({
            content: glasnevinContentString,
            //ariaLabel: "Location",
        });
        const markerGlasnevin = new google.maps.Marker({
            position: features[1].position,
            icon: icons[features[1].type].icon,
            title: features[1].title,
            //title: `${i + 1}. ${title}`,
            //styles: styles,
            map: mapGlasnevin,
        });
        markerGlasnevin.addListener("click", () => {
          //infoWindow.close(); // Doesn't work - need a static window and switch content/position
          //infoWindow.setContent(contentString);
          glasnevinInfoWindow.open({
            anchor: markerGlasnevin,
            mapGlasnevin,
          });
        });
    }
    
    if(document.querySelector(".map-glasnevin")) { // For multiple maps
        mapGlasnevin = new google.maps.Map(document.querySelector(".map-glasnevin"), {
            //center: new google.maps.LatLng(53.320999, -6.354760),
            center: new google.maps.LatLng(53.373720, -6.295250),
            disableDefaultUI: true,
            //styles: styles,
            zoom: 11,
        });
        const glasnevinContentString = // TODO grab HTML from page
        '<div id="content"><div id="siteNotice"></div>' +
        '<h2 id="firstHeading" class="firstHeading">'+features[1].title+'</h2>' +
        '<div id="bodyContent">' +
        '<p>'+features[1].content+'</p>' +
        '</div></div>';
        const glasnevinInfoWindow = new google.maps.InfoWindow({
            content: glasnevinContentString,
            //ariaLabel: "Location",
        });
        const markerGlasnevin = new google.maps.Marker({
            position: features[1].position,
            icon: icons[features[1].type].icon,
            title: features[1].title,
            //title: `${i + 1}. ${title}`,
            //styles: styles,
            map: mapGlasnevin,
        });
        markerGlasnevin.addListener("click", () => {
          //infoWindow.close(); // Doesn't work - need a static window and switch content/position
          //infoWindow.setContent(contentString);
          glasnevinInfoWindow.open({
            anchor: markerGlasnevin,
            mapGlasnevin,
          });
        });
        // map = new google.maps.Map(document.querySelector(".map-location"), {
        //     center: new google.maps.LatLng(53.354999, -6.324760),
        //     disableDefaultUI: true,
        //     //styles: styles,
        //     zoom: 11,
        // });
    }

}